import * as yup from 'yup';

export const whatsappTemplateSchema = yup.object({
  title: yup.string().required('Template title is required').max(512),
  category: yup.string().required('Category is required'),
  body: yup
    .string()
    .required('Message body is required')
    .max(1024, 'Max 1024 characters'),
  internalNote: yup.string().max(500).default(''),
});

export type WhatsAppTemplateFormData = yup.InferType<
  typeof whatsappTemplateSchema
>;
